import {combineReducers} from "redux"
import hourglassState from "./hourglassReducer"
import {
  product2d,
  products2d,
  product2dActivePart,
  product2dCanvasState,
  LWAState,
  product2dBaseColor,
  activeObj,
  activeObjs,
  d2Loader,
} from "./product2dReducer"
import {options, apiKey} from "./dataApiReducers"
import {makFabric} from "./canvasApiReducer"
import {fbdata} from "./fbdata"
import {products} from "./products"

export default combineReducers({
  hourglassState,
  product2d,
  products2d,
  makFabric,
  product2dActivePart,
  product2dCanvasState,
  LWAState,
  product2dBaseColor,
  activeObj,
  activeObjs,
  d2Loader,
  options,
  apiKey,
  fbdata,
  products
})
